var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xóa dữ liệu trùng",
            visible: _vm.showDeleteAttendanceDuplicateDialog,
            width: "700px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "10vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDeleteAttendanceDuplicateDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          size: "medium",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          format: "dd-MM-yyyy",
                          placeholder: "Chọn ngày",
                          clearable: false,
                        },
                        model: {
                          value: _vm.dataInput.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "date", $$v)
                          },
                          expression: "dataInput.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            loading: _vm.buttonLoading1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.checkAttendanceDuplicate()
                            },
                          },
                        },
                        [_vm._v("KTra điểm danh\n         ")]
                      ),
                      _vm._v(
                        "\n            KQ:" +
                          _vm._s(_vm.countAttendanceDuplicate) +
                          "  \n         "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            disabled: _vm.countAttendanceDuplicate === 0,
                            loading: _vm.buttonLoading2,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteAttendanceDuplicate()
                            },
                          },
                        },
                        [_vm._v("Xóa điểm danh\n         ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            loading: _vm.buttonLoading3,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.checkEvaluateDuplicate()
                            },
                          },
                        },
                        [_vm._v("KTra nhận xét\n          ")]
                      ),
                      _vm._v(
                        "\n             KQ:" +
                          _vm._s(_vm.countEvaluateDuplicate) +
                          "  \n          "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            disabled: _vm.countEvaluateDuplicate === 0,
                            loading: _vm.buttonLoading4,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteEvaluateDuplicate()
                            },
                          },
                        },
                        [_vm._v("Xóa nhận xét\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            loading: _vm.buttonLoading5,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.checkQrCodeDuplicate()
                            },
                          },
                        },
                        [_vm._v("KTra mã QR\n          ")]
                      ),
                      _vm._v(
                        "\n             KQ:" +
                          _vm._s(_vm.countQrCodeDuplicate) +
                          "  \n          "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            disabled: _vm.countQrCodeDuplicate === 0,
                            loading: _vm.buttonLoading6,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteQrCodeDuplicate()
                            },
                          },
                        },
                        [_vm._v("Xóa mã QR\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }